var __rest = this && this.__rest || function (s, e) {
    var t = {};
    for (var p in s)
        if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
            t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === 'function')
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)
            if (e.indexOf(p[i]) < 0)
                t[p[i]] = s[p[i]];
    return t;
};
import assign from './assign';
import nodeFactory, { register } from './factory';
import Type from './Type';
export class Generic {
    constructor(_a) {
        var {content, modal, copy} = _a, rest = __rest(_a, [
                'content',
                'modal',
                'copy'
            ]);
        this.type = Type.Modal;
        this.content = nodeFactory(content, copy);
        this.modal = nodeFactory(modal, copy);
        const descriptors = Object.getOwnPropertyDescriptors(this);
        descriptors.type.configurable = false;
        descriptors.type.writable = false;
        descriptors.content.configurable = false;
        descriptors.modal.configurable = false;
        Object.defineProperties(this, descriptors);
        assign(this, copy, Object.assign({}, rest));
    }
}
export class Modal extends Generic {
}
export const klass = Modal;
export default Modal;
register(Type.Modal, Modal);    //# sourceMappingURL=Modal.js.map
